import React from 'react';
import { Link } from 'react-router-dom';
import contractsData from '../data/contracts.json';

const Contracts = (props)=>{
	return (
		<div className="contracts container-fluid">
			<div className="container p-0 text-center">
				<h2>Legal Documents, Forms, and Contracts</h2>
				<div className="card-deck">
					
					<div className="card">
						<div className="card-body">
							<i className="fa fa-home" aria-hidden="true"></i>
							<h4 className="card-title">Real Estate</h4>
							<div className="card-text">
								<ul>
									<li>
										<Link to="/contracts/real-estate/contract-to-sell" data-toggle="tooltip" data-placement="right" title={contractsData.contracts[0].category["Real Estate"][0].description}>Contract to Sell</Link>
									</li>
									<li>
										<Link to="/contracts/real-estate/deed-of-absolute-sale" data-toggle="tooltip" data-placement="right" title={contractsData.contracts[0].category["Real Estate"][1].description}>Deed of Absolute Sale</Link>
									</li>
									<li>
										<Link to="/contracts/real-estate/real-estate-mortgage" data-toggle="tooltip" data-placement="right" title={contractsData.contracts[0].category["Real Estate"][2].description}>Real Estate Mortgage</Link>
									</li>
								</ul>
							</div>
						</div>
						<div className="card-footer">
							<Link to="/contracts/real-estate" className="btn btn-lightblue">View All</Link>
						</div>
					</div>
				
					<div className="card">
						<div className="card-body">
							<i className="fa fa-users" aria-hidden="true"></i>
							<h4 className="card-title"><strong>FREE</strong> Contracts</h4>
							<div className="card-text">
								<ul>
									<li>
										<Link to="/contracts/free-contracts/board-resolution-to-sell" data-toggle="tooltip" data-placement="right" title={contractsData.contracts[1].category["Free Contracts"][0].description}>Board Resolution (to Sell)</Link>
									</li>
									<li>
										<Link to="contracts/free-contracts/earnest-money-agreement" data-toggle="tooltip" data-placement="right" title={contractsData.contracts[1].category["Free Contracts"][1].description}>Earnest Money Agreement</Link>
									</li>
									<li>
										<Link to="/contracts/free-contracts/option-contract" data-toggle="tooltip" data-placement="right" title={contractsData.contracts[1].category["Free Contracts"][2].description}>Option Contract</Link>
									</li>
									<li>
										<Link to="/contracts/free-contracts/secretary-certificate-to-sell" data-toggle="tooltip" data-placement="right" title={contractsData.contracts[1].category["Free Contracts"][3].description}>Secretary's Certificate (to Sell)</Link>
									</li>
									<li>
										<Link to="/contracts/free-contracts/special-power-of-attorney-to-sell" data-toggle="tooltip" data-placement="right" title={contractsData.contracts[1].category["Free Contracts"][4].description}>Special Power of Attorney (to Sell)</Link>
									</li>
								</ul>
							</div>
						</div>
						<div className="card-footer">
							<Link to="/contracts/free-contracts" className="btn btn-lightblue">View All</Link>
						</div>
					</div>
				
					<div className="card">
						<div className="card-body">
							<i className="fa fa-briefcase" aria-hidden="true"></i>
							<h4 className="card-title">Business</h4>
							<div className="card-text">
								<ul>
									<li>
										<Link to="/contracts/business/promissory-note" data-toggle="tooltip" data-placement="right" title={contractsData.contracts[2].category["Business"][0].description}>Promissory Note</Link>
									</li>
									<li>
										<Link to="/contracts/business/deed-of-sale-of-motor-vehicle" data-toggle="tooltip" data-placement="right" title={contractsData.contracts[2].category["Business"][1].description}>Deed of Sale of Motor Vehicle</Link>
									</li>
								</ul>
							</div>
						</div>
						<div className="card-footer">
							<Link to="/contracts/business" className="btn btn-lightblue">View All</Link>
						</div>
					</div>
					
				</div>
			</div>
		</div>
	);
}

export default Contracts;


// WEBPACK FOOTER //
// ./src/view/Contracts.js